class ErrorManager {
    
  static  #errors = [];

  static addError(error) {
    if (error && typeof error === 'string') {
      if (!this.#errors.includes(error)) {
          this.#errors.push(error);
        }
    }
  }

  static getErrors() {
    return this.#errors;
  }

  static hasErrors() {
    return this.#errors.length > 0;
  }

  static clearErrors() {
    this.#errors = [];
  }
}

export default ErrorManager;